import React from 'react'
import MainLayout from '../layout/MainLayout';
import { Link } from 'react-router-dom';

function PrivacyPolicy() {
    return (
        <MainLayout>
            <title>RSBS Privacy Policy</title>
            <div className="text-content">
                <h1>PRIVACY POLICY</h1>
                <b>Last Updated: September 24, 2026</b><br /><br />
                <p>This Privacy Policy explains how we collect, use, and protect your information when you register and interact with our website.</p>
                <h2>1. Information We Collect</h2>
                <p>When you register for an account, we collect and store the following information:</p>
                <ul><li>Name or Alias: Used to identify your profile on the site.</li>
                    <li>Email Address: Used for account verification and communications.</li>
                    <li>Password: Stored securely to protect your account access.</li>
                </ul>
                <h2>2. How We Use Your Information</h2>
                <p>We use your collected data strictly for the following purposes:</p>
                <ul>
                    <li>Account Administration: To create, maintain, and secure your registered account.</li>
                    <li>Public Display: Your registered name or alias will be publicly displayed next to any content, comments, or debates you post.</li>
                    <li>Site Notifications: We will use your email address to notify you about site activities.</li>
                </ul>
                <h2>3. Email Communication Choices</h2>
                <p>We respect your inbox. You have full control over your notifications:</p>
                <ul>
                    <li>You can completely disable site activity emails at any time.</li>
                    <li>To opt out, update your preferences directly within your Account Settings</li>
                </ul>
                <h2>4. Data Sharing and Protection</h2>
                <p>Your trust is critical to us.</p>
                <ul><li>No Sale of Data: We do not sell, trade, or give away user email addresses to third parties.</li>
                    <li>Tracking Technologies: For details on how we use tracking files, please see our separate <Link to="/CookiePolicy.html">Cookie Policy</Link>.</li>
                </ul>
                <h2>5. Account Cancellation and Data Retention</h2>
                <p>You have the right to un-register from our system at any time.
                    Because our site relies on interactive debate threads and comment sections, your content is handled as follows upon cancellation:</p>
                <ul><li>Profile Anonymization: Your account will be permanently deactivated.</li>
                    <li>Content Attribution: Your posted comments and debate content will remain visible to preserve the conversational flow.</li>
                    <li>Identity Removal: All remaining content will be scrubbed of your name and relabeled as "deleted user #XXX."</li></ul>
                <h2>6. Contact Us</h2>
                <p>If you have any questions about this Privacy Policy or wish to un-register your account, please contact us through our website's <Link to="./Contact.html">support channels</Link>.</p>
            </div>
        </MainLayout>
    )
}

export default PrivacyPolicy
